export const REDUCER_NAME = 'version-summary'




// WEBPACK FOOTER //
// ./src/modules/process/state/version-summary/const.js